import React from 'react';
import { createPortal } from 'react-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { versionLog } from '../data/versionLog';

const VersionLogModal = ({ open, onClose }) => {
  if (!open) return null;

  const content = (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          style={{
            position: 'fixed',
            inset: 0,
            width: '100vw',
            height: '100vh',
            height: '100dvh',
            zIndex: 999999,
            background: 'rgba(15, 23, 42, 0.55)',
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 18,
            boxSizing: 'border-box',
          }}
          onClick={onClose}
        >
          <motion.div
            initial={{ y: 20, scale: 0.96, opacity: 0 }}
            animate={{ y: 0, scale: 1, opacity: 1 }}
            exit={{ y: 16, scale: 0.98, opacity: 0 }}
            transition={{ type: 'spring', damping: 28, stiffness: 360 }}
            style={{
              width: '100%',
              maxWidth: 430,
              maxHeight: '84vh',
              maxHeight: '84dvh',
              overflowY: 'auto',
              background: '#ffffff',
              borderRadius: 16,
              boxShadow: '0 24px 60px rgba(15, 23, 42, 0.28)',
              border: '1px solid rgba(148, 163, 184, 0.35)',
              padding: '22px 20px',
              fontFamily: 'Arial, sans-serif',
              textAlign: 'left',
              boxSizing: 'border-box',
              margin: 'auto',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 12,
              marginBottom: 18,
            }}>
              <div>
                <p style={{
                  margin: '0 0 4px',
                  fontSize: 12,
                  fontWeight: 700,
                  color: '#0ea5e9',
                  textTransform: 'uppercase',
                  letterSpacing: '0.08em',
                }}>
                  Changelog Aplikasi
                </p>
                <h3 style={{
                  margin: 0,
                  fontSize: 18,
                  fontWeight: 700,
                  color: '#0f172a',
                }}>
                  Riwayat Pembaruan
                </h3>
              </div>

              <button
                type="button"
                onClick={onClose}
                aria-label="Tutup log versi"
                style={{
                  border: 'none',
                  background: '#f1f5f9',
                  color: '#475569',
                  borderRadius: 9999,
                  width: 32,
                  height: 32,
                  cursor: 'pointer',
                  fontSize: 18,
                  fontWeight: 700,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                &times;
              </button>
            </div>

            {versionLog.map((item, index) => (
              <section
                key={item.version}
                style={{
                  borderTop: index === 0 ? 'none' : '1px solid #e2e8f0',
                  paddingTop: index === 0 ? 0 : 14,
                  marginTop: index === 0 ? 0 : 14,
                }}
              >
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: 8,
                  marginBottom: 8,
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      background: index === 0 ? '#e0f2fe' : '#f8fafc',
                      color: index === 0 ? '#0369a1' : '#475569',
                      border: `1px solid ${index === 0 ? '#bae6fd' : '#e2e8f0'}`,
                      borderRadius: 9999,
                      padding: '2px 10px',
                      fontSize: 12,
                      fontWeight: 700,
                    }}>
                      v{item.version}
                    </span>
                    {index === 0 && (
                      <span style={{
                        fontSize: 11,
                        color: '#0284c7',
                        fontWeight: 700,
                      }}>
                        Versi Terbaru
                      </span>
                    )}
                  </div>

                  <span style={{
                    fontSize: 12,
                    color: '#64748b',
                    whiteSpace: 'nowrap',
                  }}>
                    {item.date}
                  </span>
                </div>

                <ul style={{
                  margin: 0,
                  paddingLeft: 20,
                  color: '#334155',
                  fontSize: 14,
                  lineHeight: 1.55,
                }}>
                  {item.changes.map((change) => (
                    <li key={change} style={{ marginBottom: 8 }}>
                      {change}
                    </li>
                  ))}
                </ul>
              </section>
            ))}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );

  return typeof document !== 'undefined' ? createPortal(content, document.body) : content;
};

export default VersionLogModal;
